var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFunnel = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "currentcolor",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.5 2.75A.75.75 0 0 0 3.75 2H2v12h1.75a.75.75 0 0 0 .75-.75V2.75zM9.25 6c0-.707 0-1.06-.22-1.28-.22-.22-.573-.22-1.28-.22h-1v7h1c.707 0 1.06 0 1.28-.22.22-.22.22-.573.22-1.28V6zM13.25 6a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-.75.75H11.5V6h1.75z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgFunnel);
export default ForwardRef;